export const CHILD_RANDOM_SEARCH_REQUEST = 'CHILD_RANDOM_SEARCH_REQUEST';
export const CHILD_RANDOM_SEARCH_SUCCESS = 'CHILD_RANDOM_SEARCH_SUCCESS';
export const CHILD_RANDOM_SEARCH_FAIL = 'CHILD_RANDOM_SEARCH_FAIL';
export const CHILD_RANDOM_SEARCH_RESET = 'CHILD_RANDOM_SEARCH_RESET';

export const CHILD_BY_TOKEN_REQUEST = 'CHILD_BY_TOKEN_REQUEST';
export const CHILD_BY_TOKEN_SUCCESS = 'CHILD_BY_TOKEN_SUCCESS';
export const CHILD_BY_TOKEN_FAIL = 'CHILD_BY_TOKEN_FAIL';
export const CHILD_BY_TOKEN_RESET = 'CHILD_BY_TOKEN_RESET';

export const CHILD_BY_ID_REQUEST = 'CHILD_BY_ID_REQUEST';
export const CHILD_BY_ID_SUCCESS = 'CHILD_BY_ID_SUCCESS';
export const CHILD_BY_ID_FAIL = 'CHILD_BY_ID_FAIL';
export const CHILD_BY_ID_RESET = 'CHILD_BY_ID_RESET';

export const CHILD_NEEDS_REQUEST = 'CHILD_NEEDS_REQUEST';
export const CHILD_NEEDS_SUCCESS = 'CHILD_NEEDS_SUCCESS';
export const CHILD_NEEDS_FAIL = 'CHILD_NEEDS_FAIL';
export const CHILD_NEEDS_RESET = 'CHILD_NEEDS_RESET';

export const CHILD_ONE_NEED_REQUEST = 'CHILD_ONE_NEED_REQUEST';
export const CHILD_ONE_NEED_SUCCESS = 'CHILD_ONE_NEED_SUCCESS';
export const CHILD_ONE_NEED_FAIL = 'CHILD_ONE_NEED_FAIL';
export const CHILD_ONE_NEED_RESET = 'CHILD_ONE_NEED_RESET';

export const CHILD_ONE_NEED_RECEIPT_REQUEST = 'CHILD_ONE_NEED_RECEIPT_REQUEST';
export const CHILD_ONE_NEED_RECEIPT_SUCCESS = 'CHILD_ONE_NEED_RECEIPT_SUCCESS';
export const CHILD_ONE_NEED_RECEIPT_FAIL = 'CHILD_ONE_NEED_RECEIPT_FAIL';
export const CHILD_ONE_NEED_RECEIPT_RESET = 'CHILD_ONE_NEED_RECEIPT_RESET';
